import { LEGAL_ADMIN, LEGAL_DOCUMENT_EFFECTIVE_DATE, LEGAL_DOCUMENT_VERSION } from './constants'
import type { LegalDocumentContent } from './types'

export const cookiesContent: LegalDocumentContent = {
  slug: 'cookies',
  documentTitle: 'Cookie',
  h1: 'Cookie',
  version: LEGAL_DOCUMENT_VERSION,
  effectiveDate: LEGAL_DOCUMENT_EFFECTIVE_DATE,
  intro: [
    `Кратко о том, какие cookie и локальные данные использует «${LEGAL_ADMIN.brandName}» (${LEGAL_ADMIN.siteHost}).`,
  ],
  sections: [
    {
      id: 'necessary',
      title: '1. Нужны для входа',
      paragraphs: [
        'Для авторизации и сессии используются необходимые cookie (в том числе HttpOnly). Без них вход в аккаунт не работает.',
      ],
    },
    {
      id: 'localstorage',
      title: '2. LocalStorage',
      paragraphs: [
        'После нажатия «Принять» в баннере сохраняется флаг `proka_cookie_consent_accepted`, чтобы баннер не показывался снова. На вход это не влияет.',
      ],
    },
    {
      id: 'not-used',
      title: '3. Чего нет',
      paragraphs: [
        'Рекламных и аналитических cookie (например, Google Analytics) в текущей версии нет.',
      ],
    },
    {
      id: 'control',
      title: '4. Управление',
      paragraphs: [
        'Можно удалить cookie в настройках браузера — тогда вход может стать недоступен. Выход из аккаунта завершает текущую сессию.',
      ],
    },
    {
      id: 'contact',
      title: '5. Контакт',
      paragraphs: [
        `Вопросы: ${LEGAL_ADMIN.contactEmail}. Подробнее о данных — в разделе [[privacy|Конфиденциальность]].`,
      ],
    },
  ],
  relatedLinks: [
    { label: 'Конфиденциальность', slug: 'privacy' },
    { label: 'Правила сообщества', slug: 'rules' },
  ],
}
